import { FC } from "react";
import { IconProps } from "./types";

export const ExclamationPoint: FC<IconProps> = ({
  fill = "#000",
  innerFill = "#fff",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <g clipPath="url(#hapa2x00qa)">
      <path
        d="M12 0C5.35 0 0 5.35 0 12s5.35 12 12 12 12-5.35 12-12S18.65 0 12 0zm0 19.1c-.7 0-1.25-.55-1.25-1.25S11.3 16.6 12 16.6s1.25.55 1.25 1.25S12.7 19.1 12 19.1zm1.25-5.7c0 .7-.55 1.25-1.25 1.25s-1.25-.55-1.25-1.25V4.9c0-.7.55-1.25 1.25-1.25s1.25.55 1.25 1.25v8.5z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="hapa2x00qa">
        <path fill={innerFill} d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
